export default {
  title: 'Tämä ravintola ei voi vielä aloittaa toimintaansa',
  description:
    'Kumppanitililläsi ei ole käsittelymaksua verkkomaksuille, eikä 0 %:n marginaalia ole vahvistettu. Stripe veloittaa maksunsa alustaltasi, joten toinen näistä on päätettävä ensin.',
  partner_action:
    'Aseta oletuskäsittelymaksu tai vahvista, ettet veloita ravintoloiltasi mitään ja maksat Stripen maksut itse.',
  ask_partner:
    'Kumppanisi ei ole vielä asettanut verkkomaksujen käsittelymaksuaan. Tämä ravintola voi aloittaa toiminnan, kun maksu on asetettu.',
  buttons: {
    set_rate: 'Aseta käsittelymaksu',
    close: 'Sulje',
  },
};
